/**
 * Получить список ИД пользователей из значения реквизита формы.
 *
 * @global
 * @private
 * @ignore
 * @function _getUserList
 * @param {string} sourceVal Строка со значением реквизита.
 * @returns {number[]} Массив ИД.
 */
function _getUserList(sourceVal) {
  if (sourceVal) {
    return sourceVal.split(';').map((val) => {
      // ToDo: исправить это недоразумение
      if (val.indexOf('_') + 1) {
        return val.split('_')[1];
      } else {
        return val.split(':')[1];
      }
    });
  } else {
    return [];
  }
}

/**
 * Получить тип задания.
 *
 * @global
 * @private
 * @ignore
 * @function _getJobKind
 * @returns {JOB_KIND|integer} Тип заданий.
 */
function _getJobKind() {
  if ($('input#hiddCardContrrolJobsType').val() === 'J') {
    return JOB_KIND.JOB;
  } else {
    return JOB_KIND.NOTICE;
  }
}

/**
 * Получить селектор для срока задачи.
 *
 * @global
 * @private 
 * @function _getTaskDeadlineSelector
 * @returns {string} Селектор для срока задачи.
 */
function _getTaskDeadlineSelector() {  
    return '#CardContrrolStepsDeadline';  
}

/**
 * Получить список параметров запроса.
 *
 * @global
 * @private
 * @ignore
 * @function _getQueryParams
 * @returns {object} Параметры запроса.
 */
function _getQueryParams() {
  return {
    TaskID: WA.CR.ID,
    Subject: $('input#CardContrrolSubject').val(),
    ActiveText: $('textarea#CardContrrolEditedText').val(),
    Observers: _getUserList($('input[name=CardContrrolObservers]').val()),
    Performers: _getUserList($('input#hSelID_CardContrrolRoute').val()),
    JobKind: _getJobKind(),
    Deadline: $(_getTaskDeadlineSelector()).val() || '',
    InitiatorId: $('#hSelID_CardContrrolInitiator').val(),
    RouteType: $('#hiddCardContrrolRouteType').val() || '',
    Rights: $('#hiddCardContrrolRightsType').val(),
    IsEncyptEnabled: $('#EncryptWithCertCheck').is(':checked')
  };
}

/**
 * Обновить папку "Входящие".
 *
 * @global
 * @private
 * @ignore
 * @function _updateFolderList
 */
function _updateFolderList() {
  if (opener && opener.WA.getLocation() === 'explorer' && opener.WA.CR.objectList) {
    opener.WA.CR.objectList.reload();
  }
}

/**
 * Полное обновление вкладки Карточка.
 *
 * @global
 * @private
 * @ignore
 * @function _cardTabFullUpdate
 * @param {object} model Модель всей вкладки Карточки.
 */
function _cardTabFullUpdate(model) {
  WA.CR.initOrUpdateCardTab(model.cardTabModel);

  const headerElement = $('.react-container')[0];
  if (!WA.CR.IsNew) {
    WA.CR.initCardHeader(
      headerElement,
      model.cardHeaderModel,
    );
  }
}

/**
 * Сохранить задачу.
 *
 * @global
 * @function saveTask
 */
function saveTask() {
  WA.SRV.call('Task.asmx/Save', _getQueryParams()).done((model) => {
    let modelWrapper = JSON.parse(model);
    WA.CR.IsNew = modelWrapper.isNew;
    _cardTabFullUpdate(modelWrapper.model);
    // Раздизейблим вкладки, которые мы дизейблили в бэекенде для новой задачи.
    if (!WA.CR.IsNew) {
      let sideBarTabs = WA.CR.sideBar.tabs.toArray();
      let tabIdsToEnable = [
        TAB_TYPE.HISTORY,
        TAB_TYPE.ROUTE_SCHEME,
      ];
      let tabNamesToEnable = tabIdsToEnable.map((tabId) => {
        return WA.CR._getTabName(tabId);
      });
      sideBarTabs.forEach((tab) => {
        if (tabNamesToEnable.includes(tab.name)) {
          tab.enable();
        }
      });
    }
  });
}

/**
 * Стартовать задачу.
 *
 * @global
 * @function startTask
 * @param {object} model Модель задачи.
 * @param {ACCESS_RIGHTS} accessRights Устанавливаемые права доступа.
 */
function startTask(model = _getQueryParams(), accessRights = ACCESS_RIGHTS.NO_ACCESS) {
  const params = Object.assign(model, {
    AccessRights: accessRights,
  });  

  const callStartTask = () => {
    WA.SRV.call('Task.asmx/Start', params,null,null,true).done((maxRights) => {
      // Предпринимаем попытку старта задачи. Возможна ситуация, когда
      // исполнителям по задаче не будет хватать прав на задачу.
      // Необходимо запросить их.
      if (maxRights && maxRights != ACCESS_RIGHTS.NO_ACCESS) {
        Core.customWorks.showAccessRightsDialog(maxRights, {
          View : () => startTask(model, ACCESS_RIGHTS.VIEW),
          Change: () => startTask(model, ACCESS_RIGHTS.CHANGE),
          Full: () => startTask(model, ACCESS_RIGHTS.FULL),
          Ignore: () => startTask(model, ACCESS_RIGHTS.EMPTY),
      },  L('WARN_ASSIGN_TASK_ATTACHMENTS_RIGHTS_DLG_MSG'));
      } else {
        _updateFolderList();
        WA.CR.window.unbind('beforeClose');
        window.close();
      }
    })
      .error((errorText,result)=> {
        var maxRights = result.Result;
        if (maxRights != ACCESS_RIGHTS.NO_ACCESS) {
          let dialogMessage = L('WRN_CANNOT_SET_ATTACHMENTS_RIGHTS') + '<br/>' + errorText;
          Core.customWorks.showAccessRightsDialog(maxRights, {
            View : () => startTask(model, ACCESS_RIGHTS.VIEW),
            Change: () => startTask(model, ACCESS_RIGHTS.CHANGE),
            Full: () => startTask(model, ACCESS_RIGHTS.FULL),
            Ignore: () => startTask(model, ACCESS_RIGHTS.EMPTY),
          },  dialogMessage);
        } else {
          WA.CR.inlineHint.showError(errorText);
        }       
      });
  };

  const showTaskDeadlineActualizeDialog = () => {       
    const taskDeadlineActualizeButtons = [
      {
        id: 'ActualizeButton',
        caption: L('ACTUALIZE'),
        onClick: () => {   
          taskDeadlineActualizeDialog.bind(WA.CMP.dialogs.MessageBox.EVENT.AFTER_CLOSE, (dialog) => {
            $(_getTaskDeadlineSelector()).focus();
          });          
        },
      },
      {
        id: 'NoActualizeButton',
        caption: L('NOACTUALIZE'),
        onClick: callStartTask,
      }          
    ];
    const taskDeadlineActualizeDialog = new WA.CMP.dialogs.MessageBox();
    for (const buttonModel of taskDeadlineActualizeButtons) {          
      taskDeadlineActualizeDialog.addButton(buttonModel.id, buttonModel.caption, buttonModel.onClick);          
    }
    taskDeadlineActualizeDialog.isShowOkButton = false;        
    taskDeadlineActualizeDialog.isShowCancelButton = true;        

    taskDeadlineActualizeDialog.showQuestion(L('TASK_DEADLINE_ACTUALIZE_MSG'));    
  };


  let isDeadlineActual = true;
  if (params.Deadline) {
    const deadLine = parseDateTime(params.Deadline);
    if (deadLine) {
      // Если время не задано, то срок выполнения ставим на конец суток, чтобы корректно сравнивать с актуальной датой
      if (deadLine.getHours() === 0 && deadLine.getMinutes() === 0 && deadLine.getSeconds() === 0) {
        deadLine.setHours(23);
        deadLine.setMinutes(59);
        deadLine.setSeconds(59);
      }
      const difference = (Date.now() - deadLine.getTime());      
      isDeadlineActual = (difference <= 0);
    }  
  } 

  if (isDeadlineActual) {        
    callStartTask();    
  } else {
    showTaskDeadlineActualizeDialog();
  }         
}

/**
 * Прекратить задачу.
 *
 * @global
 * @function abortTask
 */
function abortTask() {
  WA.SRV.call('Task.asmx/Abort', {
    TaskID: WA.CR.ID
  }).done((model) => {
    _updateFolderList();
    _cardTabFullUpdate(JSON.parse(model));
  });
}

/**
 * Возобновить задачу.
 *
 * @global
 * @function restoreTask
 */
function restoreTask() {
  WA.SRV.call('Task.asmx/Restore', {
    TaskID: WA.CR.ID
  }).done((model) => {
      _updateFolderList();
      WA.CR.window.unbind('beforeClose');
      window.close();
  });
}

/**
 * Рестартовать задачу.
 *
 * @global
 * @function restartTask
 */
function restartTask() {
  WA.SRV.call('Task.asmx/Restart', {
    TaskID: WA.CR.ID
  }).done((model) => {
    _updateFolderList();
    _cardTabFullUpdate(JSON.parse(model));
  });
}

/**
 * Переключение между режимом чтения и редактирования.
 *
 * @global
 * @function toggleChange
 * @param {WA.CMP.wrappers.toolBar.ReactToolBarButton|WA.CMP.wrappers.toolBar.ToolBarButton} btn Кнопка панели действий.
 */
function toggleChange(btn) {
  const isEditMode = btn.isSelected();
  const params = {
    TaskID: WA.CR.ID,
    IsEditMode: isEditMode,
  };
  if (isEditMode && WA.CR.CardTab.mainTab && WA.CR.CardTab.mainTab.isModifiedByUser()) {
    ConfirmDialogNew(L('UNSAVED_CHANGES_WILL_BE_LOST'), () => {              
      WA.SRV.call('Task.asmx/ToggleChange', params).done((model) => _cardTabFullUpdate(JSON.parse(model)));
    });
  } else {
    WA.SRV.call('Task.asmx/ToggleChange', params).done((model) => _cardTabFullUpdate(JSON.parse(model)));    
  }   
}

/**
 * Старт задачи.
 *
 * @global
 * @function StartTask
 * @deprecated since 5.6. Use startTask function instead.
 */
function StartTask() {
  startTask();
}

/**
 * Прекращение задачи.
 *
 * @global
 * @function AbortTask
 * @deprecated since 5.6. Use abortTask function instead.
 */
function AbortTask() {
  abortTask();
}

/**
 * Рестарт задачи.
 *
 * @global
 * @function RestartTask
 * @deprecated since 5.6. Use restartTask function instead.
 */
function RestartTask() {
  restartTask();
}

/**
 * Возобновление задачи.
 *
 * @global
 * @function RestoreTask
 * @deprecated since 5.6. Use restoreTask function instead.
 */
function RestoreTask() {
  restoreTask();
}